import React from 'react';
import banner from '../img/banner.jpg';
import banner2 from '../img/banner2.png';
import banner3 from '../img/banner3.jpg';
import banner4 from '../img/banner4.jpg';



const Carousel = () => {
    return (
        <>

            <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" style={{ marginTop: '05px' }}>
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>



                </div>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={banner} className="d-block w-100" alt="Banner 1" />
                    </div>


                    <div className="carousel-item">
                        <img src={banner2} className="d-block w-100" alt="Banner 4" />
                    </div>
                    <div className="carousel-item">
                        <img src={banner3} className="d-block w-100" alt="Banner 5" />
                    </div>

                    <div className="carousel-item">
                        <img src={banner4} className="d-block w-100" alt="Banner 5" />
                    </div>

                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev" style={{background:'none'}}>
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next" style={{background:'none'}} >
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>

        </>
    );
}

export default Carousel;
